// extracted by mini-css-extract-plugin
export default {"tasksGrid":"TaskList_tasksGrid__arS3M","noTask":"TaskList_noTask__TUr+p"};